import { notify } from '@bynder/design-system';
import creativesService from 'packages/services/creativesService';
import { catchResponseError } from 'packages/helpers/helpers';
import * as types from '~/store/types';

export function fetchCreative(id, inEditor = false) {
    return async (dispatch) => {
        if (!inEditor) {
            dispatch({ type: types.GET_CREATIVE_REQUEST });
        }

        const res = await creativesService.fetchCreative(id).catch(catchResponseError);

        if (!res || res.status !== 200) {
            notify({
                title: 'Oops! Something went wrong. Please refresh your page.',
                variant: 'error',
            });

            return;
        }

        const sortable = [] as any;

        const { creative } = res;

        if ('data_schema' in creative && 'properties' in creative.data_schema) {
            for (const key in creative.data_schema.properties) {
                sortable.push([key, creative.data_schema.properties[key].displayOrder]);
            }
        }

        sortable.sort((a, b) => a[1] - b[1]);

        const dynamicFields = [] as any;
        sortable.forEach((value) => dynamicFields.push(value[0]));

        dispatch({ type: types.GET_CREATIVE_SUCCESS, dynamicFields, creative });
    };
}
